import React from 'react'
import { BiSolidPhoneCall } from 'react-icons/bi';
import { GrMail } from 'react-icons/gr';

function Footer() {
    return (
        <div>
            <footer className="text-gray-600 body-font">

                <div className="pb-[1%]">
                    <div className="container mx-auto py-4 px-5 flex flex-wrap flex-col sm:flex-row">
                        <p className="text-gray-300 text-sm font-semibold text-center mx-auto sm:text-left">copyright © 2023 Naman Bansal
                        </p>
                    </div>
                </div>
            </footer >
        </div >
    )
}

export default Footer
